(() => {
  const initRoomGalleries = (scope = document) => {
    scope.querySelectorAll('.fd-cg--room-gallery, .fd-rh--gallery').forEach((gallery) => {
      if (gallery.dataset.fdLightboxReady === 'true') return;

      gallery.querySelectorAll('.fd-cg__lightbox-trigger, .fd-rh__lightbox-trigger').forEach((trigger) => {
        const opener = trigger.closest('[data-modal]');
        const modal = opener ? document.querySelector(opener.dataset.modal) : null;
        if (!modal) return;

        const closeButton = modal.querySelector('.fd-cg-lightbox__close, .fd-rh-lightbox__close');
        const closeModal = () => {
          if (typeof modal.hide === 'function') {
            modal.hide();
          } else {
            modal.removeAttribute('open');
            document.body.classList.remove('overflow-hidden');
            trigger.focus();
          }
        };

        trigger.addEventListener('click', () => {
          if (trigger.disabled) return;

          if (!modal.hasAttribute('open')) {
            if (typeof modal.show === 'function') {
              modal.show(trigger);
            } else {
              modal.setAttribute('open', '');
            }
          }

          document.body.classList.add('overflow-hidden');
          closeButton?.focus();
        });

        closeButton?.addEventListener('click', closeModal);
        modal.addEventListener('click', (event) => {
          if (event.target === modal) closeModal();
        });
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeModal();
        });
      });

      gallery.dataset.fdLightboxReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRoomGalleries());
  } else {
    initRoomGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initRoomGalleries(event.target));
})();
